import Icon from "@mdi/react";
import {
	mdiHome,
	mdiNewspaper,
	mdiViewDashboard,
	mdiCalendar,
	mdiAirplaneTakeoff,
	mdiAirplane,
	mdiAccountMultiple,
	mdiSchool,
	mdiCreditCard,
	mdiTriangleOutline,
	mdiChartBar,
	mdiEmailOutline,
	mdiFileDocumentEditOutline,
	mdiWrench,
	mdiSecurity,
} from "@mdi/js";

// components
import { dropDownOptions } from "components/DropDownMenu";

// tools
import { Module } from "tools/Enums";

const homeIcon = <Icon path={mdiHome} size={1} color="grey" />;
const newsIcon = <Icon path={mdiNewspaper} size={1} color="grey" />;
const dashboardIcon = <Icon path={mdiViewDashboard} size={1} color="grey" />;
const scheduleIcon = <Icon path={mdiCalendar} size={1} color="grey" />;
const flightsIcon = <Icon path={mdiAirplaneTakeoff} size={1} color="grey" />;
const aircraftIcon = <Icon path={mdiAirplane} size={1} color="grey" />;
const usersIcon = <Icon path={mdiAccountMultiple} size={1} color="grey" />;
const coursesIcon = <Icon path={mdiSchool} size={1} color="grey" />;
const invoicesIcon = <Icon path={mdiCreditCard} size={1} color="grey" />;
const smsIcon = <Icon path={mdiTriangleOutline} size={1} color="grey" />;
const reportsIcon = <Icon path={mdiChartBar} size={1} color="grey" />;
const mailingIcon = <Icon path={mdiEmailOutline} size={1} color="grey" />;
const documentsIcon = <Icon path={mdiFileDocumentEditOutline} size={1} color="grey" />;
const camoIcon = <Icon path={mdiWrench} size={1} color="grey" />;
const adminIcon = <Icon path={mdiSecurity} size={1} color="grey" />;

export default class GetModule {
	static getName(module) {
		switch (module) {
			case Module.Home:
				return "Home";
			case Module.News:
				return "News";
			case Module.Dashboard:
				return "Dashboard";
			case Module.Schedule:
				return "Schedule";
			case Module.Flights:
				return "Flights";
			case Module.Aircraft:
				return "Aircraft";
			case Module.Users:
				return "Users";
			case Module.Courses:
				return "Courses";
			case Module.Invoices:
				return "Invoices";
			case Module.Sms:
				return "Sms";
			case Module.Reports:
				return "Reports";
			case Module.Mailing:
				return "Mailing";
			case Module.Documents:
				return "Documents";
			case Module.Camo:
				return "Camo";
			case Module.Admin:
				return "Admin";
		}
	}

	static getDropDownItem(module) {
		switch (module) {
			case Module.Home:
				return new dropDownOptions(homeIcon, "Home", "", 0);
			case Module.News:
				return new dropDownOptions(newsIcon, "News", "", 1);
			case Module.Dashboard:
				return new dropDownOptions(dashboardIcon, "Dashboard", "", 2);
			case Module.Schedule:
				return new dropDownOptions(scheduleIcon, "Schedule", "", 3);
			case Module.Flights:
				return new dropDownOptions(flightsIcon, "Flights", "", 4);
			case Module.Aircraft:
				return new dropDownOptions(aircraftIcon, "Aircraft", "", 5);
			case Module.Users:
				return new dropDownOptions(usersIcon, "Users", "", 6);
			case Module.Courses:
				return new dropDownOptions(coursesIcon, "Courses", "", 7);
			case Module.Invoices:
				return new dropDownOptions(invoicesIcon, "Invoices", "", 8);
			case Module.Sms:
				return new dropDownOptions(smsIcon, "Sms", "", 9);
			case Module.Reports:
				return new dropDownOptions(reportsIcon, "Reports", "", 10);
			case Module.Mailing:
				return new dropDownOptions(mailingIcon, "Mailing", "", 11);
			case Module.Documents:
				return new dropDownOptions(documentsIcon, "Documents", "", 12);
			case Module.Camo:
				return new dropDownOptions(camoIcon, "Camo", "", 13);
			case Module.Admin:
				return new dropDownOptions(adminIcon, "Admin", "", 14);
		}
	}
}
export const dropDownModuleOptionsArray = [
	GetModule.getDropDownItem(Module.Home),
	GetModule.getDropDownItem(Module.News),
	GetModule.getDropDownItem(Module.Dashboard),
	GetModule.getDropDownItem(Module.Schedule),
	GetModule.getDropDownItem(Module.Flights),
	GetModule.getDropDownItem(Module.Aircraft),
	GetModule.getDropDownItem(Module.Users),
	GetModule.getDropDownItem(Module.Courses),
	GetModule.getDropDownItem(Module.Invoices),
	GetModule.getDropDownItem(Module.Sms),
	GetModule.getDropDownItem(Module.Reports),
	GetModule.getDropDownItem(Module.Mailing),
	GetModule.getDropDownItem(Module.Documents),
	GetModule.getDropDownItem(Module.Camo),
	GetModule.getDropDownItem(Module.Admin),
];
